import React from 'react'
import Breadcrumb from 'components/layout/Breadcrumb'

const BlogBreadcrumb = () => {
  return <Breadcrumb links={[{ name: 'Blog', to: '/blog' }]} />
}

export default BlogBreadcrumb
